@use '@lib/assets/styles/main.scss' as *;

.loginWrap {
  height: 100%;
  @include responsive(null, $md1) {
    padding-bottom: 68px;
    position: relative;
  }
}

.loginActions {
  @include responsive(null, $md1) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.loginActionsRow {
  display: flex;
  gap: 12px;

  > * {
    flex: 1;
  }
}

.ssoSection {
  margin-bottom: 24px;
  container-type: inline-size;
}

.ssoButtons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  @container (max-width: 460px) {
    grid-template-columns: repeat(2, 1fr);
  }

  &.ssoButtonsSingle {
    grid-template-columns: 1fr;
  }

  &.ssoButtonsDouble {
    grid-template-columns: 1fr 1fr;
  }
}

.divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.dividerLine {
  flex: 1;
  height: 1px;
  background: $gray200;
}

.dividerText {
  color: $gray500;
  white-space: nowrap;
}

.headerCentered {
  text-align: center;
}

.titleCentered {
  margin-bottom: 8px;
}

.textCentered {
  margin-bottom: 32px;
}
